/* Brinde: sachê de teste de sensibilidade em todo pedido (substitui o que a Yever fazia).
   Sachê Hidratante Corporal Reforço Protetor (PRHCRP10G desde 30/10/2026), cadastrado a R$ 0,01 no Shopify
   (sem desconto, para nenhum cupom anular o brinde). Este script garante que o item entre
   no carrinho por qualquer caminho até o checkout: carrinho, "Comprar agora", botão de
   finalizar e quiz (window.PeleRaraBrinde.garante). Sempre 1 unidade, e nunca sozinho. Kit de avaliação profissional fica de
   fora: já é outro programa de brinde.
   Kit de 5 sachês da oferta do WhatsApp (30/10/2026): sempre 5 unidades, nunca sozinho, e no lugar do brinde. */
(function () {
  var BRINDE_VARIANT_ID = 43494524125319;
  var KIT_VARIANT_ID = 46376682127495;
  var KIT_QTD = 5;
  var EXCLUI_VARIANT_IDS = [45945664077959, KIT_VARIANT_ID];
  var BRINDE_ITEM = { id: BRINDE_VARIANT_ID, quantity: 1, properties: { Brinde: 'Teste de sensibilidade' } };
  var CFG = window.PeleRaraCart || {};
  var SACHE_KIT_ID = Number(CFG.giftVariant) || 0;
  var SACHE_KIT_MIN = Number(CFG.giftMount) || 0;
  var SACHE_KIT_ITEM = { id: SACHE_KIT_ID, quantity: 1, properties: { Brinde: CFG.giftLabel || 'Kit de sachês' } };
  var emCurso = null;

  function temVariante(itens, ids) {
    return itens.some(function (it) { return ids.indexOf(it.variant_id) !== -1; });
  }

  function ehBrinde(it) {
    return it.variant_id === BRINDE_VARIANT_ID || it.variant_id === KIT_VARIANT_ID || it.variant_id === SACHE_KIT_ID;
  }

  // Valor que conta para a meta do kit: total do carrinho sem os brindes.
  function baseMeta(c) {
    var brindes = (c.items || []).filter(ehBrinde).reduce(function (s, it) { return s + it.final_line_price; }, 0);
    return (c.total_price || 0) - brindes;
  }

  function precisa(cart) {
    return !!(cart && cart.items && cart.items.length) &&
      !temVariante(cart.items, [BRINDE_VARIANT_ID]) && !temVariante(cart.items, EXCLUI_VARIANT_IDS);
  }

  // Kit de sachês: entra sozinho quando o carrinho passa da meta e sai quando cai abaixo dela.
  function ajustaKitSaches(c) {
    if (!SACHE_KIT_ID || !SACHE_KIT_MIN) return null;
    var itens = c.items || [];
    var outros = itens.filter(function (it) { return !ehBrinde(it); }).length;
    var alvo = outros && baseMeta(c) >= SACHE_KIT_MIN ? 1 : 0;
    var atuais = itens.filter(function (it) { return it.variant_id === SACHE_KIT_ID; });
    if (!atuais.length) return alvo ? function () { return adiciona([SACHE_KIT_ITEM]); } : null;
    var passos = [];
    atuais.forEach(function (it, i) {
      var q = i === 0 ? alvo : 0;
      if (it.quantity !== q) passos.push(function () { return muda(it.key, q); });
    });
    if (!passos.length) return null;
    return function () { return passos.reduce(function (p, f) { return p.then(f); }, Promise.resolve()); };
  }

  function carrinho() {
    return fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); });
  }

  function adiciona(itens) {
    return fetch(window.routes.cart_add_url, Object.assign(fetchConfig('json'), { body: JSON.stringify({ items: itens }) }))
      .then(function (r) { return r.json(); });
  }

  function avisaTema() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'brinde-sensibilidade' });
    }
  }

  function muda(chave, quantidade) {
    return fetch(window.routes.cart_change_url, Object.assign(fetchConfig('json'), { body: JSON.stringify({ id: chave, quantity: quantidade }) }))
      .then(function (r) { return r.json(); });
  }

  // Um sachê de brinde (ou 5 do kit) por pedido, e só junto de outro produto: corrige a quantidade e tira o que ficou
  // sozinho. Com o kit no carrinho, o sachê do brinde sai.
  function corrige(c) {
    var itens = c.items || [];
    var outros = itens.filter(function (it) { return !ehBrinde(it); }).length;
    var temKit = temVariante(itens, [KIT_VARIANT_ID]);
    var passos = [];
    [[BRINDE_VARIANT_ID, temKit ? 0 : 1], [KIT_VARIANT_ID, KIT_QTD]].forEach(function (par) {
      itens.filter(function (it) { return it.variant_id === par[0]; }).forEach(function (it, i) {
        var alvo = outros && i === 0 ? par[1] : 0;
        if (it.quantity !== alvo) passos.push(function () { return muda(it.key, alvo); });
      });
    });
    var kitSaches = ajustaKitSaches(c);
    if (kitSaches) passos.push(kitSaches);
    if (!passos.length) return null;
    return passos.reduce(function (p, f) { return p.then(f); }, Promise.resolve());
  }

  // Confere o carrinho e põe o sachê se faltar. Resolve sempre, mesmo com erro: nunca trava a compra.
  function garante(cart) {
    if (emCurso) return emCurso;
    emCurso = (cart ? Promise.resolve(cart) : carrinho())
      .then(function (c) {
        var ajuste = corrige(c);
        if (ajuste) return ajuste.then(function () { avisaTema(); return true; });
        if (!precisa(c)) return false;
        return adiciona([BRINDE_ITEM]).then(function () { avisaTema(); return true; });
      })
      .catch(function () { return false; })
      .finally(function () { emCurso = null; });
    return emCurso;
  }

  function vaiAoCheckout() {
    if (typeof window.endShopping === 'function') window.endShopping();
    else window.location.href = '/checkout';
  }

  // "Comprar agora": adiciona o produto do formulário junto com o sachê e abre o checkout.
  function comprarAgora(evento, botao) {
    var pf = botao.closest('product-form');
    var form = botao.closest('form') || (pf && pf.querySelector('form'));
    if (!form || !form.querySelector('[name="id"]')) return;
    evento.preventDefault();
    evento.stopImmediatePropagation();
    var dados = new FormData(form);
    var item = { id: Number(dados.get('id')), quantity: Number(dados.get('quantity') || 1), properties: {} };
    dados.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) item.properties[m[1]] = v;
    });
    carrinho()
      .then(function (c) {
        var itens = [item];
        if (EXCLUI_VARIANT_IDS.indexOf(item.id) === -1 && !temVariante(c.items || [], [BRINDE_VARIANT_ID].concat(EXCLUI_VARIANT_IDS))) {
          itens.push(BRINDE_ITEM);
        }
        return adiciona(itens);
      })
      .then(function () { return garante(); })
      .catch(function () {})
      .finally(vaiAoCheckout);
  }

  document.addEventListener('click', function (evento) {
    var alvo = evento.target;
    if (!alvo || !alvo.closest) return;
    var compra = alvo.closest('.shopify-payment-button__button, shopify-buy-it-now-button');
    if (compra) return comprarAgora(evento, compra);

    // Finalizar compra antes de o sachê entrar: segura o clique, garante e segue.
    var finalizar = alvo.closest('[name="checkout"], a[href="/checkout"]');
    if (!finalizar || finalizar.dataset.brindeOk) return;
    evento.preventDefault();
    evento.stopImmediatePropagation();
    garante().then(function () {
      finalizar.dataset.brindeOk = '1';
      vaiAoCheckout();
    });
  }, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
      if (evento && evento.source === 'brinde-sensibilidade') return;
      garante(evento && evento.cartData && evento.cartData.items ? evento.cartData : null);
    });
  }

  // No carrinho e na gaveta, o kit aparece como "5 un." sem o seletor de quantidade, igual ao brinde.
  function travaKit() {
    document.querySelectorAll('input[data-quantity-variant-id="' + KIT_VARIANT_ID + '"]').forEach(function (campo) {
      var seletor = campo.closest('quantity-popover');
      if (!seletor || seletor.dataset.kitTravado) return;
      seletor.dataset.kitTravado = '1';
      seletor.style.display = 'none';
      var p = document.createElement('p');
      p.className = 'cart-item__brinde';
      p.textContent = KIT_QTD + ' un. · kit da oferta';
      seletor.parentNode.insertBefore(p, seletor);
    });
  }

  window.PeleRaraBrinde = { garante: garante };

  function inicia() {
    garante();
    travaKit();
    new MutationObserver(travaKit).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia);
  else inicia();
})();
